/* Cool Change Co: collection + search pages (sort, floating filter button). */
(function () {
  if (window.ccCollReady) return;
  window.ccCollReady = true;
  function init() {
    var form = document.querySelector('[data-cc-facets-form]');
    document.querySelectorAll('[data-cc-sort]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        if (!form) return;
        var inner = form.querySelector('[name="sort_by"]');
        if (inner) inner.value = sel.value;
        form.submit();
      });
    });
    var pill = document.querySelector('[data-cc-facets-pill]');
    var grid = document.getElementById('cc-grid');
    if (pill && grid && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { pill.classList.toggle('is-on', en[0].isIntersecting); }, { rootMargin: '0px 0px -10% 0px' }).observe(grid);
    } else if (pill) {
      pill.classList.add('is-on');
    }
    if (form) {
      form.addEventListener('submit', function () {
        form.querySelectorAll('input[type="number"]').forEach(function (i) { if (i.value === '') i.disabled = true; });
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
